import { createRoot } from "react-dom/client";
import React from "react";
import { FrameSearch } from "~assets/frontend/frame/frm-search/FrameSearch";
export const frameSearchLoader = (searches) => {
    searches.forEach((element) => {
        const root = createRoot(element);
        root.render(React.createElement(FrameSearch, null));
    });
};
